import styled from 'styled-components';
import {Typography} from '@/components/Typography';
import {Flexbox, FlexFullGrow, interceptProps} from '@/styled-components';
import {palette} from '@/styles';
import {CloseButton, MinimizeButton, WindowHeader} from './StyledComponents';

interface IProps {
  id?: string;
  prefix?: string;
  title?: string; // 분석 제목
  isMinimize?: boolean;
  badgeColor?: string;
  children?: React.ReactNode | React.ReactNode[];
  onClose?(): void; // 창 닫기
  onMinimize?(): void; // 창 최소화
}

export const TitleBar = ({
  id,
  prefix,
  title,
  isMinimize,
  badgeColor,
  children,
  onClose,
  onMinimize,
}: IProps) => {
  return (
    <WindowHeader>
      <Body>
        {!!id?.length && (
          <Badge color={badgeColor || '#4A81D5'}>
            <Typography variant="medium12" fontWeight="700">
              {id.toUpperCase()}
            </Typography>
          </Badge>
        )}
        {!!prefix?.length && <Text color={palette.gray500}>{prefix}</Text>}
        {!!title?.length && (
          <Text ellipsis title={title} color={palette.textPrimary}>
            {title}
          </Text>
        )}
        {!!children && children}
        <FlexFullGrow />
        {!!onMinimize && (
          <MinimizeButton isMin={isMinimize} onClick={onMinimize} />
        )}
        {!!onClose && <CloseButton onClick={onClose} />}
      </Body>
    </WindowHeader>
  );
};

const Badge = styled('div').withConfig({
  shouldForwardProp: interceptProps(['color']),
})`
  padding: 5px 8px;
  border-radius: 5px;
  flex-shrink: 0;
  color: ${palette.white};
  ${({color}) => `background-color: ${color};`}
`;

const Body = styled(Flexbox)`
  padding: 8px 16px;
  gap: 4px;
`;

const Text = styled(Typography).attrs({
  variant: 'medium14',
  fontWeight: '500',
})`
  display: block;
  white-space: nowrap;
`;
